export default __webpack_public_path__ + "static/media/c_8.f2f53fea.svg";